export default {
  index: [
    {
      path: '/zkorderinfo',
      component: resolve => require(['./zkorderinfoIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/zkorderinfo/_router.js